module.exports = __webpack_public_path__ + "img/pizza.4bffff15.png";